import { useState } from 'react';
import Sheet from '@/components/ui/Sheet';
import { OURO } from '@/pages/loja/identidade';

interface Props {
  minutos: number;
}

const PASSOS = [
  'Suas fichas ficam guardadas aqui. Não precisa retirar tudo de uma vez.',
  'Na barraca, toque no produto que você quer e confirme quantas fichas vai pegar agora.',
  'Mostre o QR do vale para quem está servindo. Ele vale por alguns minutos.',
];

// Link discreto que abre a explicação em três passos. Nada fica aberto na tela.
export default function ComoFunciona({ minutos }: Props) {
  const [aberto, setAberto] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        className="mx-auto mt-5 flex min-h-[48px] cursor-pointer items-center gap-1.5 whitespace-nowrap px-2 text-[12.5px] font-semibold underline decoration-white/25 underline-offset-4 transition-colors hover:text-white"
        style={{ color: OURO }}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-question-line" aria-hidden />
        </span>
        Como funciona?
      </button>

      <Sheet aberto={aberto} titulo="Como funciona" aoFechar={() => setAberto(false)}>
        <ol className="space-y-3">
          {PASSOS.map((texto, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-[13px] font-extrabold text-primary-700">
                {i + 1}
              </span>
              <span className="min-w-0 text-[15px] leading-relaxed text-foreground-800">{texto}</span>
            </li>
          ))}
        </ol>
        <p className="mt-4 rounded-[14px] bg-background-100 px-4 py-3 text-[13px] leading-relaxed text-foreground-700">
          Gere o vale só quando estiver na fila: ele vale por {minutos} minutos. Se o tempo acabar,
          é só gerar outro — suas fichas continuam guardadas.
        </p>
        <button
          type="button"
          onClick={() => setAberto(false)}
          className="aperta mt-4 h-[48px] w-full cursor-pointer whitespace-nowrap rounded-[14px] bg-primary-500 text-[15px] font-bold text-white transition-colors hover:bg-primary-600"
        >
          Entendi
        </button>
      </Sheet>
    </>
  );
}